import { api } from "./api";

export const integrations = {
  status: () => api.get("/integrations").then((r) => r.data),
  saveKeys: (payload) => api.put("/integrations/keys", payload).then((r) => r.data),
  googleAuthUrl: () => api.get("/integrations/google/auth-url").then((r) => r.data),
  googleDisconnect: () => api.post("/integrations/google/disconnect").then((r) => r.data),
  pagespeed: (url, strategy) =>
    api.get("/integrations/pagespeed", { params: { url, strategy } }).then((r) => r.data),
  bing: () => api.get("/integrations/bing").then((r) => r.data),
  searchConsole: (start_date, end_date, dimension = "query") =>
    api
      .get("/integrations/search-console", { params: { start_date, end_date, dimension } })
      .then((r) => r.data),
  analytics: (start_date, end_date) =>
    api.get("/integrations/analytics", { params: { start_date, end_date } }).then((r) => r.data),
  businessProfile: () => api.get("/integrations/business-profile").then((r) => r.data),
  schemaValidate: (url) => api.post("/integrations/schema/validate", { url }).then((r) => r.data),
};

export function errDetail(err, fallback = "Something went wrong") {
  return err?.response?.data?.detail || err?.message || fallback;
}
